import { colors } from '../partners/tokens'

const shadows = {
  offering: {
    shadowColor: colors.primary['800'],
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.34,
    shadowRadius: 10,
    elevation: 2,
  },
  cardSoft: {
    shadowColor: colors.primary['800'],
    shadowOffset: {
      width: 4,
      height: 4,
    },
    shadowOpacity: 0.05,
    shadowRadius: 16,
    elevation: 2,
  },
}

export default shadows
